import { useMemo, useState } from 'react'
import * as RetornoHttp from '../../../../../services/api/https/deliveries/retorno.http'

import { errorHandler } from '../../../../../services/util/error.service'
import { DateTime } from 'luxon'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  LOADING_EDIT: 'Adquirindo informações para edição',
  SAVE_UPDATE: 'Retornando veículo',
  SUCCESS: 'Veículo retornado com sucesso',
}

const INITIAL_FLEET = {
  fleet_id: 0,
}

const FIELD_ERRORS_MESSAGE = {
  returned_time: 'O campo Data de Retorno deve ser preenchido',
}

export const INITIAL_STATE = {
  fleet: { ...INITIAL_FLEET },
  returned_time: new Date(),
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useModalRetornarVeiculo() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    const throwError = fieldName =>
      setState(prevState => ({ ...prevState, errorMessage: FIELD_ERRORS_MESSAGE[fieldName] }))

    const fieldIsValid = field =>
      field && field !== 0 && (typeof field === 'string' ? field.trim() !== '' : true)

    const areFieldsValid = ({ returned_time }) => {
      const fields = { returned_time }
      let fieldsNames = Object.keys(fields)
      return fieldsNames.every(fieldName => {
        if (!fieldIsValid(fields[fieldName])) {
          throwError(fieldName)
          return false
        }
        return true
      })
    }

    return {
      // Actions
      saveUpdateDelivery(fleet, returned_time) {
        const returned_time_formatted = DateTime.fromJSDate(returned_time).toISO()

        RetornoHttp.putRetornarVeiculo(fleet.fleet_id, { returned_time: returned_time_formatted })
          .then(() =>
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.SUCCESS,
            })),
          )
          .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          ...INITIAL_STATE,
        }))
      },

      resetError() {
        setState(prevState => ({
          ...prevState,
          errorMessage: null,
          loadingMessage: LOAD_MESSAGE.NONE,
        }))
      },

      // Events
      onInit(fleet) {
        setState({ ...INITIAL_STATE, fleet, loadingMessage: LOAD_MESSAGE.NONE })
      },

      onInputChange(name, value) {
        setState(prevState => {
          prevState[name] = value
          return { ...prevState }
        })
      },

      onBtnSalvarClicked() {
        if (areFieldsValid({ returned_time: state.returned_time })) {
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE_UPDATE }))
        }
      },
    }
  }, [])

  return { state, localDispatch }
}
